import React, { useState } from 'react';
import bellIcon from '../Assets/Bell-icon.png';
import profileImage from '../Assets/User-avatar.png';
import menuIcon from '../Assets/Hamburger-menu.png';

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="w-full px-4 sm:px-6 md:px-10 pt-6 flex flex-col items-center relative">
      <div className="w-full max-w-[1344px] px-6 py-4 relative bg-gradient-to-r from-orange-600/50 to-white/50 rounded-[20px] shadow-[0px_4px_24px_0px_rgba(0,0,0,0.16)] backdrop-blur-[48px] flex items-center justify-between gap-10 overflow-hidden z-10">

        {/* 🔶 Background Gradient */}
        <div className="absolute inset-0 bg-gradient-to-r from-red-500/30 to-transparent -z-10 rounded-[20px]" />

        {/* 🔶 Logo */}
        <div className="text-base sm:text-lg md:text-2xl font-extrabold font-syne text-stone-800 whitespace-nowrap">
          Let’s Figure it Out
        </div>

        {/* ✅ Desktop Nav */}
        <div className="hidden md:flex gap-9">
          <p className="text-base font-semibold font-plusJakarta text-stone-800 hover:underline">Home</p>
          <p className="text-base font-semibold font-plusJakarta text-stone-800 hover:underline">Features</p>
        </div>

        {/* 👤 Avatar + 🔔 + ☰ */}
        <div className="flex items-center gap-4 sm:gap-6">
          {/* Profile Icon */}
          <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full overflow-hidden outline outline-[2.5px] outline-orange-600 shrink-0">
            <img
              src={profileImage}
              alt="User avatar"
              className="w-full h-full object-cover rounded-full border border-transparent"
            />
          </div>

          {/* Bell Icon */}
          <div className="w-6 h-6 sm:w-7 sm:h-7 shrink-0">
            <img
              src={bellIcon}
              alt="Notifications"
              className="w-full h-full object-contain"
            />
          </div>

          {/* Hamburger Icon */}
          <div
            onClick={toggleMobileMenu}
            className="w-6 h-6 sm:w-7 sm:h-7 cursor-pointer md:hidden relative z-20"
          >
            <img
              src={menuIcon}
              alt="Menu"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>

      {/* ✅ Dropdown menu OUTSIDE header container */}
      {isMobileMenuOpen && (
        <div className="absolute right-6 top-[95px] sm:top-[100px] w-40 bg-white rounded-xl shadow-xl z-30 py-2 animate-fadeIn">
          <p className="px-4 py-2 hover:bg-orange-100 cursor-pointer text-stone-800 font-plusJakarta text-sm font-semibold">Home</p>
          <p className="px-4 py-2 hover:bg-orange-100 cursor-pointer text-stone-800 font-plusJakarta text-sm font-semibold">Features</p>
        </div>
      )}
    </div>
  );
};

export default Header;
